import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircleIcon, ArrowLeftIcon, ShoppingBagIcon } from '@heroicons/react/24/outline';

const SuccessMessage = ({ customer }) => {
    const navigate = useNavigate();

    return (
        <div className="space-y-8 py-8">
            <div className="flex flex-col items-center justify-center space-y-4">
                <div className="relative">
                    <div className="w-32 h-32 bg-primary/10 rounded-full flex items-center justify-center animate-[pulse_2s_ease-in-out_infinite]">
                        <div className="w-24 h-24 bg-primary/20 rounded-full flex items-center justify-center animate-[pulse_2s_ease-in-out_infinite] delay-75">
                            <div className="w-16 h-16 bg-primary/60 rounded-full flex items-center justify-center scale-0 animate-[scale-in_0.5s_ease-out_forwards]">
                                <CheckCircleIcon className="h-full w-full text-white" />
                            </div>
                        </div>
                    </div>
                    <div className="absolute -top-1 -right-1 w-6 h-6 bg-primary rounded-full animate-[ping_1s_cubic-bezier(0,0,0.2,1)_infinite]"></div>
                    <div className="absolute -bottom-1 -left-1 w-4 h-4 bg-primary rounded-full animate-[ping_1s_cubic-bezier(0,0,0.2,1)_infinite_0.2s]"></div>
                </div>
                <h3 className="text-2xl font-bold text-center bg-gradient-to-r from-primary to-primary/70 bg-clip-text text-transparent animate-[fade-in_1s_ease-out]">
                    Commande créée avec succès !
                </h3>
                <p className="text-center text-primary animate-[fade-in_1s_ease-out_0.3s]">
                    Votre commande a été enregistrée et sera traitée dans les plus brefs délais.
                </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 justify-center mt-8">
                <button
                    type="button"
                    className="btn btn-outline btn-primary btn-md flex-1"
                    onClick={() => window.location.assign(`/clients/${customer.id}`)}
                >
                    <ArrowLeftIcon className="h-5 w-5 mr-2" />
                    Retour client
                </button>
                <button
                    type="button"
                    className="btn btn-outline btn-primary btn-md flex-1"
                    onClick={() => navigate('/mon-compte/commandes')}
                >
                    <ShoppingBagIcon className="h-5 w-5 mr-2" />
                    Voir mes commandes
                </button>
            </div>
        </div>
    );
};

export default SuccessMessage; 